import { useInfiniteQuery } from "@tanstack/react-query";
import { useState } from "react";

import { Product, Ranking } from "shared/models";
import { useStoreAPI } from "shared/services/api";

export const HOT_PRODUCTS_RANKING_SLUG = "hot";

export const useRankingProducts = (id: string) => {
  const [ranking, setRanking] = useState<Ranking>(new Ranking());
  const [products, setProducts] = useState<Product[]>([]);

  const api = useStoreAPI();
  const { fetchNextPage, hasNextPage, isLoading, isFetching, isFetchingNextPage } = useInfiniteQuery(
    ["rankings/products", id],
    ({ pageParam }) => api.getRankingProducts(id, pageParam),
    {
      getNextPageParam: (last) => last?.meta.paging.next,
      enabled: !!id,
      onSuccess: ({ pages }) => {
        setRanking(new Ranking(pages[pages.length - 1].data.ranking));
        setProducts(pages.flatMap(({ data: { products } }) => products.map((p) => new Product(p))));
      },
    },
  );

  return {
    ranking,
    products,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
  };
};
